<template>
  <div>
    <div class="row">
      <div class="col-md-12 col-lg-6">
        <BreadCrumd
          :title="'Expressions de besoin'"
          :description="'Nouvelle expression de besoin'"
        />
      </div>
      <div class="col-md-12 col-lg-6">
        <Relationship
          :steps="steps"
          :currentStep="currentStep"
          class="float-lg-right mt-2"
        />
      </div>
    </div>
    <div class="mt-4 mb-4">
      <form @submit.prevent="submit" @keydown="form.onKeydown($event)">
        <alert-error
          v-if="form.errors.get('message')"
          :form="form"
          :message="form.errors.get('message')"
        ></alert-error>
        <div class="row">
          <div class="col-md-12">
            <div class="card">
              <div class="card-body mb-n2">
                <div class="row d-lg-flex justify-content-lg-center">
                  <div class="col-md-6 col-lg-2">
                    <div class="form-group">
                      <label for="date"
                        >Date <span class="text-danger">*</span></label
                      >
                      <date-picker
                        v-model="form.date"
                        name="date"
                        placeholder="Date"
                        lang="fr"
                        format="DD/MM/YYYY"
                        value-type="DD/MM/YYYY"
                      ></date-picker>
                      <input
                        class="form-control"
                        :class="{
                          'is-invalid': form.errors.has('date'),
                        }"
                        type="hidden"
                      />
                      <has-error :form="form" field="date"></has-error>
                    </div>
                  </div>
                  <div class="col-md-6 col-lg-2">
                    <div class="form-group">
                      <label for="date_reception"
                        >Date de réception
                        <span class="text-danger">*</span></label
                      >
                      <date-picker
                        v-model="form.date_reception"
                        name="date_reception"
                        placeholder="Date de réception"
                        lang="fr"
                        format="DD/MM/YYYY"
                        value-type="DD/MM/YYYY"
                      ></date-picker>
                      <input
                        class="form-control"
                        :class="{
                          'is-invalid': form.errors.has('date_reception'),
                        }"
                        type="hidden"
                      />
                      <has-error
                        :form="form"
                        field="date_reception"
                      ></has-error>
                    </div>
                  </div>
                  <div class="col-md-6 col-lg-2">
                    <div class="form-group">
                      <label for="priorite"
                        >Priorité <span class="text-danger">*</span></label
                      >
                      <v-custom-select
                        label="nom"
                        :options="priorites"
                        :reduce="(priorite) => priorite.uuid"
                        v-model="form.priorite"
                        placeholder="Priorité"
                      >
                        <template v-slot:option="{ nom }">
                          <h5 style="margin: 0">{{ nom }}</h5>
                        </template>
                        <template #no-options> Aucune donnée </template>
                        <template #search="{ attributes, events }">
                          <input
                            id="priorite"
                            class="custom-select-height vs__search"
                            v-bind="attributes"
                            v-on="events"
                          />
                        </template>
                      </v-custom-select>
                      <div>
                        <input
                          type="hidden"
                          class="form-control"
                          :class="{
                            'is-invalid': form.errors.has('priorite'),
                          }"
                        />
                        <has-error :form="form" field="priorite"></has-error>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6 col-lg-4">
                    <div class="form-group">
                      <label for="commentaire"
                        >Commentaire (max : 150 caractères )
                      </label>
                      <textarea
                        v-model="form.commentaire"
                        class="form-control"
                        :class="{
                          'is-invalid': form.errors.has('commentaire'),
                        }"
                        rows="5"
                        maxlength="150"
                      ></textarea>
                      <has-error :form="form" field="commentaire"></has-error>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row mt-n4">
          <div class="col-md-12">
            <div class="card">
              <div class="card-body mt-n2 mb-n2">
                <div class="row mt-n2 d-flex justify-content-center">
                  <div class="col-md-8 col-lg-6">
                    <cool-select
                      v-model="selectedArticle"
                      :items="articles"
                      item-text="designation"
                      placeholder="Recherche article"
                      disable-filtering-by-search
                      @search="onSearchArticle"
                      @select="onSelectedArticle"
                      :search-text.sync="searchText"
                    >
                      <template #no-data>
                        {{
                          noData
                            ? 'Aucun resultat.'
                            : '2 caratères pour lancer la recherche.'
                        }}
                      </template>
                      <template #item="{ item }">
                        <div class="item">
                          <div>
                            <h5>{{ item.designation }}</h5>
                            <span v-if="item.reference" class="d-block">
                              Référence : {{ item.reference }}
                            </span>
                            <span v-if="item.unite" class="d-block">
                              Unité : {{ item.unite }}
                            </span>
                            <span v-if="item.article_type" class="d-block">
                              Type d'article :
                              {{
                                item.article_type === 'produits'
                                  ? 'Produit'
                                  : 'Service'
                              }}
                            </span>
                          </div>
                        </div>
                      </template>
                    </cool-select>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <b-alert
          :show="itemListErrorMessage !== null"
          dismissible
          variant="danger"
        >
          <span v-html="itemListErrorMessage"></span>
        </b-alert>
        <div class="row mt-n4">
          <div class="col-md-12">
            <table class="card table table-sm">
              <thead>
                <tr class="d-flex">
                  <th class="col-4">Référence</th>
                  <th class="col-5">Désignation</th>
                  <th class="col-2 text-center">Quantité</th>
                  <th class="col-1 text-center">Action</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(item, index) in form.item_lists"
                  :key="index"
                  class="d-flex"
                >
                  <td class="col-4" style="vertical-align: middle">
                    {{ item.reference }}
                  </td>
                  <td class="col-5" style="vertical-align: middle">
                    {{ item.designation }}
                  </td>

                  <td class="col-2 text-center" style="vertical-align: middle">
                    <div class="input-group">
                      <input
                        class="form-control"
                        v-model="item.quantite"
                        type="text"
                        placeholder="Quantité"
                        @focus="$event.target.select()"
                      />
                      <div class="input-group-append bg-transparent">
                        <span
                          class="input-group-text bg-transprent border-right-0"
                        >
                          {{ item.unite }}
                        </span>
                      </div>
                    </div>
                  </td>
                  <td class="col-1 text-center" style="vertical-align: middle">
                    <a
                      class="cursor-pointer"
                      @click.prevent="removeItem(index)"
                    >
                      <i
                        :class="icons.ICON_DELETE"
                        class="font-size-17 text-danger"
                      ></i
                    ></a>
                  </td>
                </tr>
                <tr v-if="form.item_lists.length === 0" class="d-flex">
                  <td colspan="4" class="text-center col-12">Aucune donnée</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <div class="row mb-4 mt-2">
          <div class="col-md-12 text-right">
            <button
              type="button"
              class="btn btn-secondary mr-4"
              @click.prevent="
                $router
                  .push({ name: 'achat_expression_besoin' })
                  .catch(() => {})
              "
            >
              Liste des expressions de besoin
            </button>

            <ButtonLoader
              :busy="form.busy"
              type="submit"
              customClass="btn btn-custom-primary w-40"
              loadText="Traitement en cours..."
              Text="Créer"
              style="min-width: 100px"
            ></ButtonLoader>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import URL_EB from '@/http/achat/expression-besoin';
import URL_ARTICLE from '@/http/article_stock/article';
import Form from 'vform';
import { CoolSelect } from 'vue-cool-select';
import DatePicker from 'vue2-datepicker';
import { mapActions } from 'vuex';
import { mapGetters } from 'vuex';
import { create as icons } from '@/icons/achat/expression-besoin';

export default {
  data() {
    return {
      form: new Form({
        date: this.$options.filters.formatDate(new Date(), 'DD/MM/YYYY'),
        date_reception: '',
        commentaire: '',
        priorite: '',
        item_lists: [],
      }),
      priorites: [],
      articles: [],
      cloneId: null,
      selectedArticle: null,
      noData: false,
      timeoutId: null,
      searchText: null,

      itemListErrorMessage: null,
      title: 'Gestion des expressions de besoin - Création',
      icons,
    };
  },
  watch: {
    $route() {
      this.init();
    },
  },
  computed: {
    ...mapGetters('eb', ['currentStep', 'steps']),
  },
  components: {
    CoolSelect,
    DatePicker,
  },
  metaInfo() {
    return {
      title: this.title,
      titleTemplate: this.titleApp + ' | %s',
    };
  },
  created() {
    this.setCurrentStep(0);
  },
  methods: {
    ...mapActions('eb', ['setCurrentStep']),
    init() {
      this.priorites = [];

      if (this.$route.params.cloneId) {
        this.cloneId = this.$route.params.cloneId;

        window.axios
          .all([
            window.axios.get(URL_EB.GET_REQUIREMENTS),
            window.axios.get(URL_EB.EXPRESSION_BESOIN + '/' + this.cloneId, {
              params: { edit: true },
            }),
          ])
          .then(
            window.axios.spread((resp1, resp2) => {
              this.priorites = resp1.data.priorites;
              Object.assign(this.form, resp2.data.expression_besoin);
              this.form.item_lists = this.form.item_lists.map((item) => {
                return {
                  article: item.article,
                  designation: item.designation,
                  reference: item.reference,
                  unite: item.unite,
                  quantite: item.quantite,
                  stock: 0,
                };
              });
            })
          )
          .catch();
      } else {
        window.axios
          .get(URL_EB.GET_REQUIREMENTS)
          .then((resp) => {
            this.priorites = resp.data.priorites;
          })
          .catch();
      }
    },
    onSelectedArticle: function (select) {
      if (select) {
        var objExiste = window._.find(
          this.form.item_lists,
          (o) => o.article === select.uuid
        );
        if (!objExiste) {
          this.form.item_lists.push({
            article: select.uuid,
            designation: select.designation,
            reference: select.reference,
            unite: select.unite,
            quantite: 1,
            stock: 0,
          });
        } else {
          objExiste.quantite += 1;
        }

        this.searchText = null;
        this.selectedArticle = null;
        this.articles = [];
      }
    },
    async onSearchArticle(search) {
      const lettersLimit = 2;

      this.articles = [];
      this.noData = false;

      if (search.length < lettersLimit) {
        return;
      }

      clearTimeout(this.timeoutId);
      this.timeoutId = setTimeout(async () => {
        await window.axios
          .get(URL_ARTICLE.SEARCH_ARTICLE, {
            params: {
              search: search,
              onlyProduit: false,
              sortBy: 'designation',
              sortDesc: false,
            },
          })
          .then((resp) => {
            this.articles = resp.data;
          })
          .catch();

        if (!this.articles.length) {
          this.noData = true;
        } else if (this.articles.length === 1) {
          this.onSelectedArticle(this.articles[0]);
        }
      }, 500);
    },
    removeItem: function (index) {
      this.form.item_lists.splice(index, 1);
    },
    submit() {
      this.itemListErrorMessage = null;
      this.form
        .post(URL_EB.EXPRESSION_BESOIN)
        .then((resp) => {
          this.showSimpleAlerte('top-end', 'success', resp.data.message);
          this.form.reset();
          if (this.cloneId) {
            this.cloneId = null;
          }
          this.$router.push({
            name: 'achat_expression_besoin-show',
            params: { id: resp.data.expression_besoin.id },
          });
        })
        .catch((err) => {
          window._.forEach(err.response.data.errors, (value, key) => {
            if (key.includes('item_lists')) {
              this.itemListErrorMessage = value[0];
            } else {
              this.form.errors.set('message', err.response.data.message);
            }
            return 0;
          });
        });
    },
  },
  mounted() {
    this.init();
  },
};
</script>

<style scoped></style>
